import { DiscussionContextType, DiscussionType } from "@cnx/common";
import { Box } from "@mantine/core";
import { IconBuilding, IconRoute, IconTruckLoading } from "@tabler/icons-react";
import IconMessageDotsCircle from "icons/common/message-dots-circle.svg";

interface DiscussionIconProps {
  discussionType?: string;
  context?: string | null;
  stopActivityKind?: string | null;
  size?: number;
}

const ICON_SIZE = 24;

const DiscussionIcon = ({
  discussionType,
  context,
  size = 50,
}: DiscussionIconProps) => {
  if (discussionType !== DiscussionType.CONTEXT) return null;

  const getIcon = () => {
    if (context === DiscussionContextType.RESOURCE_COMBINATION) {
      return <IconRoute size={ICON_SIZE} className="text-gray-dark" />;
    }

    if (context === DiscussionContextType.SALES_ORDER_LEG) {
      return <IconTruckLoading size={ICON_SIZE} className="text-gray-dark" />;
    }

    if (context === DiscussionContextType.STOP) {
      return (
        <IconBuilding
          width={ICON_SIZE}
          height={ICON_SIZE}
          className="text-gray-dark"
        />
      );
    }

    return (
      <IconMessageDotsCircle
        width={ICON_SIZE}
        height={ICON_SIZE}
        className="text-gray-dark"
      />
    );
  };

  return (
    <Box
      style={{ width: size, height: size, borderRadius: "50%", flexShrink: 0 }}
      className="bg-gray-lightest flex items-center justify-center"
    >
      {getIcon()}
    </Box>
  );
};

export default DiscussionIcon;
